const invalidEmail = 'E-Mail ist ungültig.';
const intro = 'Präsentation';

const de: LocaleType = {
  subtitle: (...args: string[]) => `${args[0]} is ${args[1]}`,
  cancel: 'Stornieren',
  login_button: 'Anmelden',
  signout: 'Abmelden',
  loading: 'Bitte warten...',
  read_more: 'Lesen Sie mehr',
  general: {
    countryNameFI: 'Finnland',
    countryNameSE: 'Schweden',
  },
  auth: {
    successAuth: 'Erfolgreich authentifiziert. Umleitung zur Homepage',
    processing: 'Verarbeitung der Authentifizierung',
    invalidAuth: 'Ungültige Sitzung für den Benutzer.',
  },
  errors: {
    default: 'Diese Anforderung konnte nicht übermittelt werden',
    duplicate: 'Daten befinden sich bereits im System.',
    invalidEmail: invalidEmail,
    pageNotFound: 'Seite nicht gefunden',
  },
  cookie: {
    message:
      'Diese Website verwendet Cookies, um Ihnen eine großartige Benutzererfahrung zu bieten. Durch die weitere Nutzung dieser Website erklären Sie sich mit der Verwendung von Cookies in Übereinstimmung mit uns.',
    policy: 'Cookie-Richtlinie',
    accept: 'Akzeptieren',
  },
  landing_page: {
    header: {
      user: {
        hey: (...args: string[]) => `Hallo ${args[0]}, `,
        bookings: 'überprüfen Sie hier Ihre eigenen Buchungen',
        check_bookings: 'Überprüfen Sie Ihre Buchungen',
        has_reservation: 'Haben Sie bereits eine Reservierung? ',
      },
      menus: {
        home: 'Startseite',
        parks: 'Parks',
        bestpoint: 'BestPoint -Servicestelle',
        why_bestpark: 'Warum BestPark?',
        our_story: intro,
        info: 'Info',
        for_host: 'Für die Wirte',
        the_cities: 'Für die Städte',
        contact_us: 'Kontaktieren Sie uns',
        login: 'Anmelden',
        language: (...args: string[]) => `${args[0]}`,
      },
      buy_tickets: 'Tickets kaufen',
      buy: 'Kaufen',
      all_parks: 'Alle Parken',
      make_reservation: 'Jetzt buchen',
      for_host: 'Für die Wirte',
      demonstration: 'Präsentation',
      the_cities: 'Für die Städte',
      the_press: 'Für die Presse',
    },
    footer: {
      follow: 'Folgen Sie uns',
      contact: 'Kontakte',
      quick_links: 'Schnelllinks',
      traveling: 'Reisen mit Ihr',
      other_links: 'Andere links',
      privacy_statement: 'Datenschutzerklärung',
      terms_of_delivery: 'Lieferungsbedingungen',
      see_map: 'Siehe Standorte in der Karte',
      travel: 'Gemeinsam mit Ihnen unterwegs',
      privacy: 'Datenschutzerklärung',
      media: 'Für die Presse',
    },
    hero: {
      title: 'Der beste Weg zu bleiben!',
      text: 'Wir eröffnen die ersten sechs Parks für die Sommersaison 2020.',
      view_parks: 'Sehen Sie sich die Parks an',
    },
  },
  park_info: {
    header: 'Wählen Sie Ihr Ankunftsdatum aus dem Kalender',
    amenities: (...args: string[]) =>
      `${args[0]} Plätze und ${args[1]} Annehmlichkeiten`,
    faq: 'Häufig gestellte Fragen',
    extras: {
      area: 'Region',
      forWhom: 'Für wen',
      thingsToDo: 'Sehenswertes und Aktivitäten',
    },
    intro: intro,
  },
  reservation: {
    noReservation: 'Keine Reservierungen',
    continue: 'Weiter',
    previous: 'Vorherigen',
    loading: 'Bitte warten...',
    slots: {
      header: 'Wie viele Nächte übernachten Sie?',
      arrival: (...args: string[]) => `Ihr Ankunftsdatum ${args[0]}.`,
      comment: (...args: string[]) =>
        `Da das nächste Wochenende ausverkauft ist, können die maximalen Übernachtungen pro Aufenthalt ${args[0]} sein.`,
      choose: 'Parkplatz wählen',
      chooseTitle: 'Wählen Sie Ihren Parkplatz',
      unavailable: 'Unverfügbar',
      regularSlots: 'Normale Parkplätze',
      price: (...args: string[]) => `(Preis ${args[0]} ${args[1]}/nacht)`,
      addPrice: (...args: string[]) => `(Preis +${args[0]} ${args[1]}/nacht)`,
      slotError: (...args: string[]) =>
        `Slot ${args[0]} is no longer available. Select a new one.`,
    },
    coupon: {
      validateCoupon: 'Überprüfen',
      couponCode: 'Gutscheincode',
      couponInvalid: 'Gutschein ungültig',
      couponApplied: 'Coupon angewendet',
      couponDiscount: 'Gutscheinrabatt',
      couponExpired: 'Dieser Coupon ist bereits abgelaufen',
      invalidPark: 'Dieser Coupon ist nicht gültig für den ausgewählten Park',
      limitExceeded: 'Die Anzahl der Nutzungen dieses Coupons ist voll',
      userLimitExceeded: 'Dieser Coupon wurde bereits verwendet',
      shortNights:
        'Dieser Coupon ist nicht gültig für die ausgewählte Anzahl von Nächten',
      exceedingNights:
        'Dieser Coupon ist nicht gültig für die ausgewählte Anzahl von Nächten',
    },
    registration: {
      header: 'Ihre Kontaktdaten',
      subheader: 'Bestehendes BestPark-Konto?',
      login: 'Melden Sie sich hier an',
      loginNote: 'Melden Sie sich hier an',
      firstName: 'Vorname',
      lastName: 'Nachname',
      phone: 'Telefon',
      phoneInfo: 'Telefon (im internationalen Format, z. B. +358401234567)',
      email: 'E-Mail',
      street: 'Strasse',
      postalCode: 'Postleitzahl',
      town: 'Bestimmungsort',
      country: 'Land des Wohnsitzes',
      license: 'Kennzeichen des Zugfahrzeugs',
      promos:
        'Melden Sie sich für unseren Newsletter an und erfahren Sie als Erster die neuesten Nachrichten über BestPark.',
      errors: {
        fillRequired: 'Bitte füllen Sie hervorgehobene Felder aus.',
        email: invalidEmail,
        phone:
          'Die Nummer muss im internationalen Format sein, zum Beispiel +49123456.',
        emailExist: 'E-Mail ist bereits registriert.',
        fieldRequired: 'Dies ist ein Pflichtfeld',
      },
      clickHereToReserve: 'Klicken Sie hier, um Ihre Reservierung zu starten',
    },
    payment: {
      header: 'Zahlung',
      subheader:
        'Bitte wählen Sie Ihre Zahlungsmethode aus, um Ihre Reservierung abzuschließen.',
      night: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'Nächte' : 'Nacht'} im Park`,
      total: 'Gesamt',
      totalInCurrency: (...args: string[]) => `Gesamtpreis in ${args[0]}`,
      currencyConversionNote: (...args: string[]) =>
        `${args[0]} zur Zahlung in ${args[1]} umgerechnet`,
      cardPay: 'Bezahlen mit Kredit- und Debitkarten',
      mobilePay: 'Bezahlen mit mobilen Zahlungen',
      collectorBankPay: 'Bezahlen per Rechnung oder in Chargen',
      invoicePayment: 'Bezahlen per Rechnung',
      invoiceNote: (...args: string[]) =>
        `Zusätzliche Gebühr für die Festsetzung des Betrags der ${args[0]} ${
          Number(args[0]) > 1 ? 'euros' : 'euro'
        }`,
      surcharge: 'Zuschlag',
      onlineBankPay: 'Bezahlen in der Online-Bank',
      coupon: 'Haben Sie einen Gutscheincode?',
      terms1: 'Ich habe die',
      terms2: 'Geschäftsbedingungen gelesen und verstanden.',
      terms3:
        'Wir erstellen auch ein Konto für Sie für die einfachere Nutzung Ihrer BestPark Käufe.',
      pay: (...args: string[]) => `Jetzt ${args[0]} bezahlen`,
      processingPayment: 'Bearbeitung der Reservierungszahlung',
      paymentProcessed: 'Die Zahlung wurde verarbeitet.',
      paymentError:
        'Irgendetwas ist schief gelaufen! Unser Team wird sich damit befassen. Sie können sich an den Support wenden.',
      orderNumber: 'Order number: ',
      failed: 'Zahlungstransaktion abgebrochen',
    },
    card: {
      goToReservation: 'Zur Reservierung',
      days: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'Nächte' : 'Nacht'}`,
    },
    profile: {
      header: 'Ihre Reservierung',
    },
    guestInformation: {
      header: 'Meldeformular für reisende',
      firstName: 'Vorname',
      lastName: 'Nachname',
      address: 'Adresse',
      dateOfBirth: 'Geburtsdag',
      nationality: 'Staatsangehörigkeit',
      passportNumber: 'Pass',
      dateOfArrival: 'Einreisedatum',
      countryOfEntry: (...args: string[]) =>
        `Land, aus dem Einreise nach ${args[0]}`,
      addChildButton: 'Familienmitglied hinzufügen',
      addPassenger: 'Passagier hinzufügen',
      passengerInformation: 'Persönliche Daten des Passagiers',
      childSpouseInfo: 'Persönliche Daten des Familienmitglieds',
      passportInfo: (...args: string[]) =>
        `Bürger aus den nordischen Ländern oder Reisende mit Wohnsitz in ${args[0]} füllen nicht`,
      companionHeader:
        'Persönliche Daten des Ehepartners und der minderjährigen Kinder in Begleitung des Reisenden',
      subHeader:
        'Die Angabe falscher Personalien ist im Strafgesetz mit Strafe bedroht',
      delete: 'Löschen',
    },
    ancillary: {
      header: 'Zusätzliche Dienstleistungen',
      skip: 'Überspringen Sie diese',
      subheader1: 'Bleiben Sie unterwegs, während Sie geparkt sind!',
      subheader2: 'Wir haben Elektroroller und Fahrräder in allen Parks',
      subheader3:
        'Begrenzte Mänge pro Park so reservieren Sie Ihre im Voraus noch heute!',
      soldOut: 'Leider ausverkauft für alle Tage Ihres Aufenthaltes.',
      soldOutDay: (...args: string[]) =>
        `Alle ${args[0]} sind für diesen Tag reserviert`,
      price: (...args: string[]) => `${args[0]}€ pro Tag`,
      reservation: 'Wählen Sie Menge und Datum:',
      max: (...args: string[]) => `Nur ${args[0]} für diesen Tag verfügbar`,
      total: 'Gesamt:',
      totalService: (...args: string[]) =>
        `${args[0]} ${args[1]} on ${args[2]} ${
          parseInt(args[2]) > 1 ? 'Tage' : 'Tag'
        }`,
      firstDayNote:
        'Die Reservierung beginnt um 13:00 Uhr und endet am nächsten Tag um 12:00 Uhr',
      dayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
      lastDayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
    },
    details: {
      checkIn: 'Einschecken',
      checkOut: 'Ausschecken',
      info: (...args: string[]) => `
      Die Check-in-Zeit beginnt jeden Tag um  ${args[0]} und der Check-out ist bis ${args[1]}`,
      addOns: {
        earlyCheckIn: {
          info: 'Später Check-in bis 13:00 Uhr',
          button: (...args: string[]) => `Hinzufügen für ${args[0]}€`,
        },
        lateCheckOut: {
          info: ' Später Ausschecken um 15:00 Uhr',
          button: (...args: string[]) => `Hinzufügen für ${args[0]}€`,
        },
      },
      parking: {
        textSlot: 'Sitzplatz die Nummer',
        title: (...args: string[]) => `${args[0]}`,
        slot: (...args: string[]) =>
          `Wenn Sie im Park ankommen, ist Ihr reservierter ${args[0]} ${args[1]}.`,
      },
      map: {
        button: 'Navigieren zum Park',
      },
      general: {
        title: 'Der Port öffnet sich',
        text:
          'Bei der Ankunft im Park, können Sie das Tor mit diesem persönlichen Code öffnen:',
        linkInfo: (...args: string[]) =>
          `Informationen anzeigen auf ${args[0]} BestPark`,
        linkModify: 'Möchten Sie diese Reservierung ändern oder stornieren?',
        linkDownload: 'Laden Sie Ihre Quittung herunter',
        add: 'Hinzufügen',
      },
      services: {
        title: (...args: string[]) => `Deine ${args[0]}`,
        text: (...args: string[]) =>
          `Es wird hier Anweisungen haben, wo Sie die ${args[0]} abholen können, die Sie reserviert haben.`,
      },
      extendReservation: 'Reservierung verlängern',
      cancelReservation: 'Reservierung stornieren',
      cancelledReservation: 'Reservierung storniert',
    },
    confirmation: {
      confirmed: 'Reservierung bestätigt.',
      pending: 'Die Reservierung ist derzeit ausstehend.',
      confirmed_message: (...args: string[]) =>
        `Vielen Dank für Ihre Reservierung, wir freuen uns auf Ihren Besuch in ${args[0]}.`,
    },
    errors: {
      cancel: 'Sie können Ihre Buchung 7 Tage vor Anreise stornieren',
    },
    success: {
      cancel: 'Reservierung erfolgreich storniert.',
    },
    receipt: {
      invoice: (...args: string[]) => `Quittung ${args[0]}`,
      header: (...args: string[]) =>
        `Vielen Dank für Ihre Zahlung für die Buchung von  ${args[0]}, es wurde in voller Höhe für den Betrag von ${args[1]} ${args[2]}`,
      details: {
        paymentDate: 'Zahlungsdatum',
        contactEmail: 'Kontakt-E-Mail',
        chargedTo: 'Aufgeladen mit',
        chargedFree: 'Kostenlos',
        forReservation: 'Für die Buchung',
      },
      breakdown: {
        park: 'Park',
        couponUsed: 'Gutscheincode',
        couponDiscount: (...args: string[]) => `Rabatt ${args[0]} ${args[1]}`,
        serviceEntry: 'Wartung',
        subtotal: 'Teilsumme',
        grandTotal: 'Gesamt (Inkl. MSWT)',
        taxNotes: 'MSWT',
        vat: (...args: string[]) => `${args[0]} ${args[1] ?? 10}%`,
      },
      businessId: 'MwSt-Nummer',
    },
    extension: {
      full_title: 'Reservierungserweiterung nicht verfügbar',
      full_description: (...args: string[]) =>
        `Leider kann Ihre Reservierung nicht mehr verlängert werden, da der Parkplatz  ${args[0]} auf der Website von ${args[1]}  nicht mehr verfügbar ist.`,
      full_description2:
        'Sie können wieder für einen anderen Parkplatz auf unserer Buchungsseite buchen',
      book_reservation: 'Machen Sie eine neue Reservierung',
    },
  },
  promotions: {
    general: {
      read_more: 'Lesen Sie mehr',
    },
    hotline: {
      title: 'Hilfe-Service 24/7',
      text: 'Unser Kundenservice ist immer verfügbar',
      footer:
        'Der Preis für einen Anruf beträgt 8,35 Cent/Anruf + 16,69 Cent/Minute',
    },
    infos: {
      title: 'Beeinflussen!',
      text:
        'Tippen Sie auf die besten Plätze und nehmen Sie an der Verlosung der Geschenkkarte teil.',
      buttonText: 'Zur Befragung',
    },
  },
  login: {
    header: 'Melden Sie sich bei Ihrem Konto an',
    subheader: 'Noch kein Konto? ',
    registrationLink: 'Registrieren Sie sich hier',
    forgetPasswordLink: 'Passwort vergessen?',
    email: 'E-Mail',
    password: 'Passwort',
    continue: 'Weiter',
    authContent: 'Authentifizierungscode eingeben, der an ',
    errors: {
      fillRequired: 'Bitte füllen Sie hervorgehobene Felder aus.',
      email: 'E-Mail ist ungültig.',
      sessionInvalidated: 'Sitzung abgelaufen bitte melden Sie sich erneut an',
      invalidCode: 'Ungültiger Code',
    },
  },
  mail: {
    header: 'Überprüfen Sie Ihr Telefon',
    open: 'Mail-App öffnen',
    content: (...args: string[]) =>
      `Wir haben einen Login-Link an die ${args[0]} gesendet, um Sie anmelden zu können.`,
  },
  registration: {
    header: 'Registrieren eines Kontos',
    subheader: 'Bestehendes BestPark-Konto? ',
    registerButton: 'Registrieren',
    success: {
      header: 'Sie haben sich erfolgreich registriert.',
      content: 'Sie können sich jetzt bei Ihrem Konto anmelden.',
    },
  },
  profileEdit: {
    header: 'Profilkonto bearbeiten',
    subheader: 'Aktualisieren Ihrer Kontodetails',
    editButton: 'Profil bearbeiten',
    success: {
      header: 'Sie haben Ihr Konto erfolgreich aktualisiert.',
      content: 'Kundenkonto',
    },
  },
  book_category: {
    unavailable_title: (...args: string[]) =>
      `${args[0]} reservierung ist nicht möglich`,
    unavailable_description:
      'Vielleicht möchten Sie einen Wohnmobilstellplatz reservieren.',
    book_reservation: 'einen Wohnmobilstellplatz buchen',
  },
  calendar: {
    general: {
      start_reservation: 'Reservierung starten',
      select_check_in: 'Bitte wählen Sie das Eincheckdatum aus.',
      select_check_out:
        'Wählen Sie das Checkout-Datum aus und klicken Sie auf Buchung starten.',
      select_extended_check_out: 'Checkout-Datum auswählen',
      extension_title: 'Reservierung verlängern',
      extension_description:
        'Sie können die gleiche Buchung für bis zu 7 zusätzliche Nächte verlängern',
      to_pay: 'Bezahlen Sie hier',
      summary_extension: (...args: string[]) =>
        `Verlängerung der Buchung um ${args[0]}  Nächte für insgesamt ${args[1]} ${args[2]}. Neuer Check-out bis ${args[3]} um 12:00 Uhr.`,
      summary: (...args: string[]) =>
        `Reservierung von  ${args[0]} bis ${args[1]}.\nCheck in ${args[2]}, check out um ${args[3]}. Gesamtpreis: ${args[4]} ${args[5]}.`,
      cancellation_policy:
        'Kostenlose Stornierung 2 Tage vor Anreise. 50% Rückerstattung bei Stornierung bis 13:00 Uhr am Anreisetag.',
    },
    months: {
      january: 'Januar',
      february: 'Februar',
      march: 'März',
      april: 'April',
      may: 'Mai',
      june: 'Juni',
      july: 'Juli',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'Dezember',
    },
    in_months: {
      january: 'Januar',
      february: 'Februar',
      march: 'März',
      april: 'April',
      may: 'Mai',
      june: 'Juni',
      july: 'Juli',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'Dezember',
    },
    weeks: {
      monday: 'Mo',
      tuesday: 'Di',
      wednesday: 'Mi',
      thursday: 'Do',
      friday: 'Fr',
      saturday: 'Sa',
      sunday: 'So',
    },
  },
  parks: {
    from: 'Ab',
    check_advance: 'Checken Sie im Voraus',
    promotion: (...args: string[]) =>
      `Wir haben ${args[0]} moderne Parks für den Sommer ${args[1]}`,
    per_night: 'pro Tag',
    listTitle: (...args: string[]) => `Sommer ${args[0]} parks:`,
  },
  newsletter: {
    title: 'Aktuelles-Brief bestellen',
    subscribe: 'Bestellen',
    subscribeMsg:
      'Abonnieren Sie unseren Aktuelles-Brief und hören Sie als Erster die BestPark-Neuichkeiten',
    notifications: {
      subscribeSuccess: 'Vielen Dank für Ihre Kontaktaufnahme!',
      subscribeError:
        'Ihre Anfrage konnte nicht verarbeitet werden. Bitte, erneut versuchen.',
    },
  },
  mediaPage: {
    visualisation: 'Visuelle Bilder',
    stock: 'Illustrationen',
    parkImages: 'Bildgalerie',
  },
  contactUs: {
    billingHeader: 'Abrechnungsinformationen',
    businessId: 'Umsatzsteuer-Identifikationsnummer',
    paymentTerm: 'Zahlungsbedingungen',
    paymentTermValue: (term: string) => `${term} days`,
    invoiceAddress: 'E-Rechnungsadresse',
    brokerAddress: 'Vermittlersadresse',
    send: 'Abschicken',
  },
  formLabels: {
    message: 'Ihre Nachricht',
    name: 'Namen',
    email: 'E-Mail',
    place: 'Ort',
    authCode: 'Authentifizierungscode',
  },
  serviceEntry: {
    card: {
      header: 'Wartung benötigt?',
      subheader1:
        'Buchen Sie eine Wartung, die Ihnen als Zwischenstopp auf Ihrer Reise dient. Sie erhalten einen Code, der 60 Minuten nach Betreten des Parks gültig ist.',
      subheader2: 'Sie können den Besuch zwischen 7 und 22 Uhr machen.',
      cta: (...args: string[]) =>
        `Der Preis für eine Wartung beträgt ${args[0]} ${args[1]}`,
    },
    selectDate: {
      header: 'Wählen Sie das Datum für die Wartung',
      cta: 'Weiter zu den Kontaktdaten',
      reminder:
        'Der Zugangscode ist 60 Minuten ab Aktivierung am Eingangstor zum Park gültig.',
    },
    confirmation: {
      paymentProcessed: 'Die Zahlung wurde verarbeitet.',
    },
    summary: {
      buttonText: 'Wartungsbesuch ansehen',
      dayInPark: 'Wartungsbesuch',
    },
    details: {
      date: 'Zeitpunkt des Wartungsbesuchs',
      listHeader: 'Wartungsbesuche',
    },
  },
  book: {
    header: (...args: string[]) =>
      `Buchen Sie einen Platz für\n ${args[0]} BestPark`,
    headerCategory: (...args: string[]) =>
      `Buchen Sie eine ${args[0]} in\n ${args[1]} BestPark`,
    maintenanceHeader: (...args: string[]) =>
      `Buchen Sie eine Wartung bei\n ${args[0]} BestPark`,
  },
};

export default de;
